import { MyFirebase } from './my-firebase';
import { reorderArray } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { Subscription } from "rxjs/Subscription";

/*
  Firebase Object.

*/
export class MyFirebaseObject {


/*

Usage

  // Build the list
  myObject = constructor(objectRef : firebase.database.Reference)

  myObject.read() : Promise<object>   start read, and promise on first read

  myObject.end();


  acces en read sur object
    qui evolue, ne pas modifier

  update(object);
  delete()
  
  getObjectRef() : firebase.database.Reference     // get Reference

  myObject.end();   // End Observe, free ressource

*/


  //
  // Constructor
  constructor(public myFirebase: MyFirebase, public objectRef : firebase.database.Reference) {

    // this.readObject();
  }

 


  // End of operation, free all resource
  end() {
  
    if (this.refObjectSub) this.refObjectSub.unsubscribe();
    this.object = null;
  }

  // start read with subscribe, and return a promise for the first tread
  start() : Promise<any> {
    return this.readObject();
  }

   
  // Current subscription
  private refObjectSub : Subscription;
    
  // The read object
  public object : any;


  // start read with subscribe, and return a promise for the first tread
  private readObject() : Promise<any> {

    return new Promise( (resolve, reject) => { 

      this.refObjectSub = this.myFirebase.getO( this.objectRef ).subscribe( (x)=>{ 
  console.log('readObject ' + x);
        
        this.object = x;
        this.processReadChange();
        
resolve(this.object);

      }, (e)=>{
        // Error
        console.error("Error: " + e);
reject(e);        
        //console.error(e.stack);
      }, ()=>{
        // End
      });

    }); // return new Promise( (resolve, reject) => { 
  }


  private processReadChange() {

  }





  getObjectRef() {
    return this.objectRef;
  }



  update(object)  : firebase.Promise<any> {
  
    return this.objectRef.update( object );    
  }

 
  delete()  : firebase.Promise<any> {   
    
    return this.objectRef.remove();
  }



}



/*
  
*/



// WEBPACK FOOTER //
// ./src/providers/my-firebase-object.ts